export default __webpack_public_path__ + "static/media/bishop.442029f5.png";